export default "/images/Privaposts-Social media-icons.png?7a2bdab2b9f048e16b73a3028ef20278";